// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1___560607ee60600b1edf9","cls2":"buttonStyles-cls2___75d4ff80d835b6ea1a2 buttonStyles-cls1___560607ee60600b1edf9"};